<template>
  <div class="default-template">
    <div class="default-template__ttl">
      {{ question.question }}
    </div>
    <div class="default-template__sub-ttl">
      Using a scale of 0= Not at all important to 5 = Very Important, please
      rate the following features of an upcoming online platform for parents
      looking to create the perfect homeschooling or after-school experiences
      for their children
    </div>
    <div class="default-template__ranking">
      <div class="default-template__radio">
        <div>Not at all important</div>
        <input
          type="radio"
          name="ranking"
          id="0"
          value="0"
          v-model="answerText"
        />
        <label for="0">0</label>
      </div>
      <div class="default-template__radio">
        <input
          type="radio"
          name="ranking"
          id="1"
          value="1"
          v-model="answerText"
        />
        <label for="1">1</label>
      </div>
      <div class="default-template__radio">
        <input
          type="radio"
          name="ranking"
          id="2"
          value="2"
          v-model="answerText"
        />
        <label for="2">2</label>
      </div>
      <div class="default-template__radio">
        <input
          type="radio"
          name="ranking"
          id="3"
          value="3"
          v-model="answerText"
        />
        <label for="3">3</label>
      </div>
      <div class="default-template__radio">
        <input
          type="radio"
          name="ranking"
          id="4"
          value="4"
          v-model="answerText"
        />
        <label for="4">4</label>
      </div>
      <div class="default-template__radio">
        <div>Very Important</div>
        <input
          type="radio"
          name="ranking"
          id="5"
          value="5"
          v-model="answerText"
        />
        <label for="5">5</label>
      </div>
      <div class="default-template__radio">
        <div>No opinion</div>
        <input
          type="radio"
          name="ranking"
          id="6"
          value="-"
          v-model="answerText"
        />
        <label for="6">-</label>
      </div>
    </div>

    <div class="main__action">
      <button class="btn btn--grey" @click.prevent="back">Back</button>
      <button class="btn" @click.prevent="next">Next</button>
    </div>
  </div>
</template>
<script>
export default {
  name: "TextQuestion",
  props: {
    question: Object,
    answers: Object,
  },
  data() {
    return {
      answerText: "",
    };
  },
  watch: {
    question: {
      immediate: true,
      handler(val) {
        if (this.answers[val.id]) {
          this.answerText = this.answers[val.id].val;
        } else {
          this.answerText = "";
        }
      },
    },
  },
  methods: {
    next() {
      if (this.answerText === "") return;
      const answer = {
        id: this.question.id,
        val: this.answerText,
        ttl: this.question.question,
      };
      this.answerText = "";
      this.$emit("next", answer);
    },
    back() {
      this.$emit("back");
    },
  },
};
</script>
